// extracted by mini-css-extract-plugin
module.exports = {"highlight":"PuiHighLight_highlight__2Yvkt"};